import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface StatusBadgeProps {
  status: string
  size?: 'sm' | 'md'
  className?: string
}

const STATUS_STYLES: Record<string, { translationKey: string; className: string }> = {
  'in-progress': {
    translationKey: 'status.inProgress',
    className:
      'bg-[var(--status-in-progress-bg)] text-[var(--status-in-progress-text)] border-[var(--status-in-progress-border)]',
  },
  completed: {
    translationKey: 'status.completed',
    className:
      'bg-[var(--status-completed-bg)] text-[var(--status-completed-text)] border-[var(--status-completed-border)]',
  },
  'not-started': {
    translationKey: 'status.notStarted',
    className:
      'bg-[var(--status-not-started-bg)] text-[var(--status-not-started-text)] border-[var(--status-not-started-border)]',
  },
  reviewed: {
    translationKey: 'status.reviewed',
    className:
      'bg-[var(--status-completed-bg)] text-[var(--status-completed-text)] border-[var(--status-completed-border)]',
  },
}

export function StatusBadge({ status, size = 'md', className }: StatusBadgeProps) {
  const { t } = useTranslation()
  const config = STATUS_STYLES[status] ?? {
    translationKey: status,
    className:
      'bg-[var(--status-not-started-bg)] text-[var(--status-not-started-text)] border-[var(--status-not-started-border)]',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
        config.className,
        className
      )}
    >
      {t(config.translationKey)}
    </span>
  )
}
